import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/components/AuthProvider';
import { LogsTab } from '@/components/tenant/LogsTab';

const TenantLogs: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  // Check for super_admin role
  useEffect(() => {
    if (user) {
      if (user.role === 'super_admin') {
        setIsAuthorized(true);
      } else {
        navigate('/app');
      }
    }
  }, [user, navigate]);

  // If not super_admin, don't render the page
  if (!isAuthorized) {
    return null;
  }

  return (
    <div className="container mx-auto py-8 space-y-8">
      <div className="flex items-center gap-4">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={() => navigate('/app/tenants')}
          className="h-8 gap-1"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Back to Tenants</span>
        </Button>
      </div>
      
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold">System Logs</h1>
          <p className="text-muted-foreground">
            Monitor system task execution and cron job logs across the platform
          </p>
        </div>
      </div>
      
      <LogsTab />
    </div>
  );
};

export default TenantLogs; 